import { flattenValues } from "@uniformdev/canvas";
import { UniformBlogNewsCardProps } from "src/uniform/contenttypes/blogNewsCard";
import { UniformEventCardProps } from "src/uniform/contenttypes/eventCard";

import { token } from "@atlaskit/tokens";

import {
    GalleryContainer,
    BlogEventCard,
    BlogNewsCard
} from "@/libraries/design/components";

export interface UniformBlogNewsGalleryProps {
    cards: (UniformBlogNewsCardProps | UniformEventCardProps)[];
    isMotionAvailable?: boolean;
    motionDelay?: string;
    motionForward?: string;
    motionBackward?: string;
}

const UniformBlogNewsGallery = ({
    cards,
    isMotionAvailable,
    motionDelay,
    motionForward: transformForward,
    motionBackward: transformBackward
}: UniformBlogNewsGalleryProps) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const flattenedCards = flattenValues(cards as any) as (
        | UniformBlogNewsCardProps
        | UniformEventCardProps
    )[];
    return (
        <GalleryContainer
            isMotionAvailable={isMotionAvailable}
            motionDelay={motionDelay}
            gap={{
                belowMd: token("space.300"),
                aboveMd: token("space.400")
            }}
        >
            {flattenedCards.map((card, index) => {
                if (card) {
                    if ("dates" in card) {
                        return (
                            <div
                                key={index}
                                className="entry-item"
                                style={{
                                    // @ts-expect-error -- CSS custom property not in CSSProperties type
                                    "--gc-item-i": index
                                }}
                            >
                                <BlogEventCard
                                    date={card.dates}
                                    location={card.location}
                                    title={card.title}
                                    link={{
                                        href: card.ctaUrl,
                                        text: card.ctaText,
                                        dataEventProps: {
                                            "data-event": "clicked",
                                            "data-event-component":
                                                "linkButton",
                                            "data-event-container":
                                                "cardSection",
                                            "data-product-key": "uniform",
                                            "data-label": card.ctaText
                                        }
                                    }}
                                    image={{
                                        src: card.imageUrl,
                                        alt: card.imageAlt ?? ""
                                    }}
                                    motionConfig={
                                        transformForward && transformBackward
                                            ? {
                                                  transformForward,
                                                  transformBackward
                                              }
                                            : undefined
                                    }
                                />
                            </div>
                        );
                    } else {
                        return (
                            <div
                                key={index}
                                className="entry-item"
                                style={{
                                    // @ts-expect-error -- CSS custom property not in CSSProperties type
                                    "--gc-item-i": index
                                }}
                            >
                                <BlogNewsCard
                                    color={card.color}
                                    label={card.label}
                                    title={card.title}
                                    link={{
                                        href: card.ctaUrl,
                                        text: card.ctaText,
                                        dataEventProps: {
                                            "data-event": "clicked",
                                            "data-event-component":
                                                "linkButton",
                                            "data-event-container":
                                                "cardSection",
                                            "data-product-key": "uniform",
                                            "data-label": card.ctaText
                                        }
                                    }}
                                    image={{
                                        src: card.imageUrl,
                                        alt: card.imageAlt ?? ""
                                    }}
                                    motionConfig={
                                        transformForward && transformBackward
                                            ? {
                                                  transformForward,
                                                  transformBackward
                                              }
                                            : undefined
                                    }
                                />
                            </div>
                        );
                    }
                }
            })}
        </GalleryContainer>
    );
};

export default UniformBlogNewsGallery;
